import React from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { authorSelected } from "../../features/filter/filterSlice";

const RelatedVideo = ({ videoDetails }) => {
  const { id, thumbnail, title, author, views, date } = videoDetails;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleAuthorFilter = (author) => {
    dispatch(authorSelected(author));
    navigate("/");
  };
  return (
    <div className='w-full flex flex-row gap-2 mb-4'>
      <div className='relative w-[168px] h-[94px] flex-none duration-300 hover:scale-[1.03]'>
        <Link to={`/video/${id}`}>
          <img src={thumbnail} className='object-cover' alt='Some video title' />
        </Link>
        <p className='absolute right-2 bottom-2 bg-gray-900 text-gray-100 text-xs px-1 py'>12:10</p>
      </div>

      <div className='flex flex-col w-full'>
        <Link to={`/video/${id}`}>
          <p className='text-slate-900 text-sm font-semibold'>{title}</p>
        </Link>
        <p
          onClick={() => handleAuthorFilter(author)}
          className='text-gray-400 text-xs mt-2 hover:text-gray-600 cursor-pointer'
        >
          {author}
        </p>
        <p className='text-gray-400 text-xs mt-1'>
          {views} views . {date}
        </p>
      </div>
    </div>
  );
};

export default RelatedVideo;
